import { ReactElement } from 'react';

export const HeaderCellComponent = (props: { style: any }): ReactElement => {
  const { style } = props;
  return (
    <th
      {...props}
      style={{
        ...style,
        padding: 0,
      }}
    />
  );
};
